const MetedStaticData = {
 MetedStats: [
    { id: 1, name: 'MetEd Users Worldwide', value: '+880,000' },
    { id: 2, name: 'Countries & Territories Served', value: '+190' },
    { id: 3, name: 'Lessons Published on MetEd', value: '+1,000' },
  ],
  testimonials: [
    {
      id: 1,
      body: 'I\'m always using this info. Both on the line and off. Knowing what kinds of fuels are in your area can help in the event of an evacuation for civilians and what we might encounter in fire behavior.',
      author: {
        name: 'read more',
        handle: 'read more',
        imageUrl:
          '',
      },
    },
    {
        id: 2,
        body: 'I\'m a flight instructor in a leadership position.  Weather principles, along with how to spot and avoid hazardous weather, are key safety "teaching points" that I try to pass on to both students and instructors.',
        author: {
          name: 'read more',
          handle: 'read more',
          imageUrl:
            '',
        },
      },
      {
        id: 3,
        body: 'To provide more accurate weather and storm information to the network of individuals and agencies charged with protecting our local and regional community.',
        author: {
          name: 'read more',
          handle: 'readmore',
          imageUrl:
            '',
        },
      },
    // More testimonials...
  ],
  latestFeatured: [
          {
            id: 10,
            title: 'Using JPSS CrIS Water Vapor and Air Mass RGB Products',
            description: 'Elevate your analysis and forecasting capabilities in challenging high-latitude and polar regions. This rapid, focused training reveals how the Cross-Track Infrared Sounder (CrIS), aboard JPSS polar-orbiting satellites (S-NPP, NOAA-20, -21), effectively fills the crucial void left by limited geostationary views... ',
            href: 'https://learn.meted.ucar.edu/#/online-courses/133fcc61-957e-4a6d-aae1-0a7e278b9e4c',
            date: 'December 2, 2025',
            datetime: '2025-12-02',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/d67ea083-f496-4236-9430-a1d3d0fa8514/Airmass_RGB_20250925T0158.jpg",
            category: { title: 'Lesson', href: '/lessons' },

          },
          {
            id: 9,
            title: 'Private Sector Classroom Scenarios',
            description: 'The Weather, Water, and Climate (WWC) enterprise is a rapidly growing, interesting, and rewarding career field. Despite this, career opportunities and the skill sets required in the WWC private sector are not well known by students. The American Meteorological Society (AMS) Mind the Gap committee serves to bridge this gap by connecting university students, instructors, and professors to resources that will prepare them for private sector employment... ',
            href: 'https://learn.meted.ucar.edu/#/online-courses/3dae43f5-0224-492b-b8a9-7a18514af262',
            date: 'October 16, 2025',
            datetime: '2025-10-16',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/3dae43f5-0224-492b-b8a9-7a18514af262/module-cover(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 8,
            title: 'Dual-Polarization Fundamentals',
            description: 'Once an experimental type of weather radar, dual-polarized (“dual-pol”) weather radar is now deployed across the United States and many parts of the world. This lesson will introduce the basic principles of dual-pol weather radar. By the end of this lesson, learners will understand physical meanings of several commonly used polarimetric radar variables...',
            href: 'https://learn.meted.ucar.edu/#/online-courses/a1a6cba8-c509-49ba-9d50-5dc3e2184fb3',
            date: 'August 27, 2025',
            datetime: '2025-08-27',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/a1a6cba8-c509-49ba-9d50-5dc3e2184fb3/module-cover(3).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 7,
            title: 'Severe Storms Sleuthing 101: Investigating Science in the Media',
            description: 'You see a post including a link to a news story and some promotional text leading into it. Do you comment on the post? Do you share it? In this lesson, you’ll evaluate four social media posts and news headlines by applying the SIFT (Stop, Investigate, Find, Trace) digital literacy method. For each post headline...',
            href: 'https://learn.meted.ucar.edu/#/online-courses/943a6148-27bd-4ea6-955a-54039f6ac417',
            date: 'May 29, 2025',
            datetime: '2025-05-29',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/943a6148-27bd-4ea6-955a-54039f6ac417/module-cover-10315(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 6,
            title: 'Estimating Tropical Cyclone Intensity with the Dvorak Technique',
            description: 'Tropical cyclone (TC) intensity estimates provide a crucial data point for estimating the impacts of a TC and initializing forecasts. However, obtaining precise intensity measurements is challenging since in-situ observations from reconnaissance flights or buoys are expensive and hard to obtain...',
            href: 'https://learn.meted.ucar.edu/#/online-courses/603f69ee-ccf3-40bd-9499-1d7a46faea00',
            date: 'May 28, 2025',
            datetime: '2025-05-28',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/603f69ee-ccf3-40bd-9499-1d7a46faea00/module-cover-10352(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 5,
            title: 'Storm Hazards Generator',
            description: 'Can you make a thunderstorm? How about with hail? With strong winds? The Storm Hazards Generator challenges you to set just the right combinations of humidity, surface temperature, and upper-tropospheric temperature ingredients needed for a severe storm to develop. This interactive model is designed to help introductory undergraduate students and other broad audiences... ',
            href: 'https://learn.meted.ucar.edu/#/online-courses/4f9c300a-3a02-4005-a507-5b51373ef574',
            date: 'May 27, 2025',
            datetime: '2025-05-27',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/4f9c300a-3a02-4005-a507-5b51373ef574/module-cover-10359(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 4,
            title: 'Analyzing Snowfall Rate with Satellite',
            href: 'https://learn.meted.ucar.edu/#/online-courses/864b0a8d-f158-4c20-956a-261b6bdd7ff4',
            description:
              'Polar latitudes are often hindered by a lack of meteorological data. Polar-orbiting satellites help fill that gap, but there is a lack of precipitation rate data like we can get from radar imagery... until now.Take this lesson to understand the benefits, limitations, and caveats of the NOAA/NESDIS Snowfall Rate (SFR) Product... ',
            date: 'May 21, 2025',
            datetime: '2025-05-21',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/864b0a8d-f158-4c20-956a-261b6bdd7ff4/module-cover-10343.jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 3,
            title: 'Satellite Analysis of Fog in Warm Water Areas',
            href: 'https://learn.meted.ucar.edu/#/online-courses/4c142c6f-618e-40cc-aac8-76306ff256ea',
            description:
              'Satellite imagery can provide valuable insight into current atmospheric phenomena, especially in data-sparse areas over the ocean. The identification and monitoring of near-shore, offshore, and high seas fog poses a number of challenges, including limited... ',
            date: 'March 30, 2025',
            datetime: '2025-03-30',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/4c142c6f-618e-40cc-aac8-76306ff256ea/module-cover-10328(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 2,
            title: 'Forecasting Blowing Snow',
            href: 'https://learn.meted.ucar.edu/#/online-courses/b18a2d0d-0ca4-47e1-9363-00bcf5a8485d',
            description:
              'Blowing snow occurs when snow and ice particles near the surface combine with strong winds and gusts to significantly reduce visibility. Blowing snow can lead to hazardous blizzard conditions that profoundly impact those in their path, posing risks to transportation,... ',
            date: 'March 27, 2025',
            datetime: '2025-03-27',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/b18a2d0d-0ca4-47e1-9363-00bcf5a8485d/module-cover-10318(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 1,
            title: 'ASOS and AWOS Explained: Key Differences, Similarities and Uses',
            href: 'https://learn.meted.ucar.edu/#/online-courses/794f6479-67a9-4676-b50d-5e0115fbbf5c',
            description:
              'The Automated Surface Observing System (ASOS) and Automated Weather Observing Systems (AWOS) are vital components of aviation safety and meteorological data. These automated systems continuously monitor and deliver real time weather data including wind speed... ',
            date: 'February 25, 2025',
            datetime: '2025-02-25',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/794f6479-67a9-4676-b50d-5e0115fbbf5c/module-cover-10339.jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          
        ],
  latestFeaturedSpanish: [
          {
            id: 3,
            title: 'Cómo comunicar pronósticos probabilísticos',
            href: 'https://learn.meted.ucar.edu/#/online-courses/bdfec82c-08bb-48e9-8d38-9ae226da9b66',
            description:
              'La capacidad de comunicar la información probabilística de manera eficaz es un aspecto importante que el Servicio Nacional de Meteorología (National Weather Service, NWS) de los EE. UU. desea desarrollar cada vez más en su personal. Esta lección permite adquirir práctica en comunicar la información probabilística al público y a las agencias y personas a cargo de tomar decisiones.... ',
            date: '16 de septiembre de 2024',
            datetime: '2024-09-16',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/bdfec82c-08bb-48e9-8d38-9ae226da9b66/module-cover-10337(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 2,
            title: 'Conceptos básicos de integración de datos satelitales y de PNT',
            href: 'https://learn.meted.ucar.edu/#/online-courses/2e95f1a7-9adc-4980-a0b7-dc9ffd7abbf5',
            description:
              'La predicción numérica del tiempo (PNT) es una de las principales herramientas de pronóstico que tenemos a nuestra disposición. Sin embargo, identificar dónde y cuándo el modelo no capta la realidad es difícil. Para los pronósticos a corto plazo, es importante identificar dónde y cuándo la representación del modelo no coincide con la realidad a fin de poder aplicar los cambios... ',
            date: '9 de septiembre de 2024',
            datetime: '2024-09-09',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/2e95f1a7-9adc-4980-a0b7-dc9ffd7abbf5/module-cover-10334(1).jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
          {
            id: 1,
            title: 'Fundamentos de las estaciones hidrométricas — Aguas bajas',
            href: 'https://learn.meted.ucar.edu/#/online-courses/794f6479-67a9-4676-b50d-5e0115fbbf5c',
            description:
              'Esta lección prepara al personal técnico en hidrología para la eventualidad de encontrar condiciones de aguas bajas durante una visita de campo a una estación hidrométrica. Tales condiciones pueden conducir a situaciones particulares, como acumulaciones de algas y la obstrucción o el entierro del orificio del manómetro de burbuja.... ',
            date: '30 de junio de 2024',
            datetime: '2024-06-30',
            imageUrl: "https://learn.meted.ucar.edu/files/2a59c198-fcf4-4779-954f-446495fea88f/Public/Courses/79c93d66-9576-4deb-9de4-d567226e8990/module-cover-10287.jpg",
            category: { title: 'Lesson', href: '/lessons' },
          },
  ],
}

export default MetedStaticData;